// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

  firebase: {
    apiKey: 'AIzaSyCnFJ0HdBJAPT0DpZorXSvA2Lk4gtwZyUw',
    authDomain: 'swift-csv-dev.firebaseapp.com',
    databaseURL: 'https://swift-csv-dev.firebaseio.com',
    projectId: 'swift-csv-dev',
    storageBucket: 'swift-csv-dev.appspot.com',
    messagingSenderId: '490981550342',
  },
  algolia: {
    applicationId: '6FQDA9OT3O',
    apiKey: '4cd306d3219ef2d21594f654e1f40c18',
  },
  // functionsRootUrl: 'http://localhost:5001/swift-csv-dev/us-central1', // Local Emulator
  functionsRootUrl: 'https://us-central1-swift-csv-dev.cloudfunctions.net', // Swift Dev
  hostingRootUrl: 'http://localhost:4200',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
